import { i18n } from '@lingui/core';
import { useProfileProviderContext } from '../../../ProfileProvider/ProfileProvider.es.js';

var HighlyCompletedProfileButStillIncomplete = 80;
var useProfileTooltipContent = function useProfileTooltipContent() {
  var _useProfileProviderCo = useProfileProviderContext(),
    data = _useProfileProviderCo.data;
  var profile = data === null || data === void 0 ? void 0 : data.currentProfile;
  if (!profile) {
    return null;
  }
  var isPrivateProfile = profile.isPrivateProfile,
    profileCompletion = profile.profileCompletion,
    isEligibleForPublicView = profile.isEligibleForPublicView;
  var isProfileInsufficient = isPrivateProfile && !isEligibleForPublicView;
  if (isProfileInsufficient) {
    return {
      header: i18n._(
      /*i18n*/
      {
        id: "d7mIek"
      }),
      body: i18n._(
      /*i18n*/
      {
        id: "e83bwE"
      }),
      footer: i18n._(
      /*i18n*/
      {
        id: "Fuzo5L"
      })
    };
  }
  var isPrivateProfileByChoice = isPrivateProfile && profileCompletion && profileCompletion >= HighlyCompletedProfileButStillIncomplete;
  if (isPrivateProfileByChoice) {
    return {
      header: i18n._(
      /*i18n*/
      {
        id: "d7mIek"
      }),
      body: i18n._(
      /*i18n*/
      {
        id: "ziEWxy"
      }),
      footer: i18n._(
      /*i18n*/
      {
        id: "nMVFSp"
      })
    };
  }
  var isProfilePublicUncompleted = !isPrivateProfile && profileCompletion && profileCompletion < HighlyCompletedProfileButStillIncomplete;
  if (isProfilePublicUncompleted) {
    return {
      header: i18n._(
      /*i18n*/
      {
        id: "TdW6jm"
      }),
      body: i18n._(
      /*i18n*/
      {
        id: "JMt3DW"
      }),
      footer: i18n._(
      /*i18n*/
      {
        id: "Fuzo5L"
      })
    };
  }
  return null;
};

export { useProfileTooltipContent };
